import { faCircleXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import FileUpload from '../../../form/FileUpload';
import { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import apiClient from '../../../../service/apiClient';

interface IPImagesId {
  ids: { file: File; id: string }[];
  setIds: React.Dispatch<React.SetStateAction<{ file: File; id: string }[]>>;
}

/**
 * @author taulmax
 * @date 2024.10.13
 * @description 상품 등록 페이지 - 상품 이미지
 */
const PImage = ({ ids, setIds }: IPImagesId) => {
  const [files, setFiles] = useState<File[]>([]);

  useEffect(() => {
    const uploadProductImages = async (file: File) => {
      const formData = new FormData();
      formData.append('file', file);

      try {
        const response = await apiClient.post('/upload-file/upload', formData);
        const tempFile = { file: file, id: response.data.id };
        setIds(ids => [...ids, tempFile]);
      } catch (error) {
        console.error('이미지 업로드 실패:', error);
        toast.error('이미지 업로드를 실패했습니다.');
      }
    };

    if (files.length > 0) {
      files.forEach(file => uploadProductImages(file));
      setFiles([]);
    }
  }, [files, setIds]);

  const onClickDelete = useCallback(
    (e: React.MouseEvent<HTMLButtonElement>) => {
      const currentImage = e.currentTarget.getAttribute('data-name');
      setIds(files => files.filter(file => file.file.name !== currentImage));
    },
    [setIds]
  );

  const getGridCols = () => {
    const count = ids.length;
    if (count === 0) return "!grid-cols-1";
    if (count === 1) return "!grid-cols-1";
    if (count === 2) return "!grid-cols-2";
    return "!grid-cols-3";
  };

  return (
    <div className="!space-y-4">
      {ids.length === 0 ? (
        <div className="!aspect-square !border-2 !border-dashed !border-gray-300 !rounded-lg hover:!border-gray-400 hover:!bg-gray-50 !transition-all !cursor-pointer">
          <FileUpload setFiles={setFiles} accept="image/*" multiple={true} />
        </div>
      ) : (
        <div className={`!grid ${getGridCols()} !gap-2`}>
          {ids.map((file, index) => (
            <div key={index} className="!relative !group">
              <div className="!aspect-square !rounded-lg !overflow-hidden !border-2 !border-gray-200">
                <img
                  src={URL.createObjectURL(file.file)}
                  alt={`preview-${index}`}
                  className="!w-full !h-full !object-cover"
                />
              </div>
              <button 
                className="!absolute !top-1 !right-1 !px-1 !py-0.5 !bg-red-500 !text-white !text-xs !rounded hover:!bg-red-600 !transition-colors !border-0"
                onClick={onClickDelete}
                data-name={file.file.name}
                type="button"
              >
                삭제
              </button>
            </div>
          ))}
          <div className="!aspect-square !border-2 !border-dashed !border-gray-300 !rounded-lg hover:!border-gray-400 hover:!bg-gray-50 !transition-all !cursor-pointer">
            <FileUpload setFiles={setFiles} accept="image/*" multiple={true} />
          </div>
        </div>
      )}
    </div>
  );
};

export default PImage;
